// extracted by mini-css-extract-plugin
export default {"container":"IngredientsSection-module__container__jFOXM","title":"IngredientsSection-module__title__aACLy","text":"IngredientsSection-module__text__NgCUn"};